import { parseChatMarkdown } from './chatMarkdownParser.js';
const object = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
const text = (value, max) => typeof value === 'string' && !!value.trim() && value.length <= max && !/[\u0000-\u0008\u000b-\u001f\u007f]/.test(value);
const id = (value) => typeof value === 'string' && /^[a-zA-Z0-9_-]{1,64}$/.test(value);
/** Treat model-produced UI metadata as bounded display data, never commands or consent. */
export function parseQuestions(value) {
    if (!Array.isArray(value) || !value.length || value.length > 3)
        return undefined;
    const result = [];
    const ids = new Set();
    for (const item of value) {
        if (!object(item) || !id(item.id) || ids.has(item.id) || !text(item.question, 500)
            || (item.header !== undefined && !text(item.header, 60)) || item.allowOther !== true
            || !Array.isArray(item.options) || item.options.length < 2 || item.options.length > 4)
            return undefined;
        const options = [];
        const optionIds = new Set();
        const labels = new Set();
        for (const option of item.options) {
            if (!object(option) || !id(option.id) || option.id === 'other' || optionIds.has(option.id) || !text(option.label, 100)
                || labels.has(option.label.trim().toLocaleLowerCase()) || (option.description !== undefined && !text(option.description, 300))
                || (option.recommended !== undefined && typeof option.recommended !== 'boolean'))
                return undefined;
            optionIds.add(option.id);
            labels.add(option.label.trim().toLocaleLowerCase());
            options.push({ id: option.id, label: option.label.trim(), ...(typeof option.description === 'string' ? { description: option.description.trim() } : {}), ...(option.recommended === true ? { recommended: true } : {}) });
        }
        if (options.filter(option => option.recommended).length > 1)
            return undefined;
        ids.add(item.id);
        result.push({ id: item.id, question: item.question.trim(), ...(typeof item.header === 'string' ? { header: item.header.trim() } : {}), options: options.sort((a, b) => Number(!!b.recommended) - Number(!!a.recommended)), allowOther: true });
    }
    return result;
}
/** Older Gyro services already return question text plus answer chips. Upgrade that explicit pattern only. */
export function questionsForReply(content, followups, structured) {
    const parsed = parseQuestions(structured);
    if (parsed)
        return parsed;
    if (!Array.isArray(followups) || followups.length < 2 || followups.length > 5)
        return undefined;
    // Ignore code examples and quotes: a question inside a source is not a request to the user.
    const prose = parseChatMarkdown(content).flatMap(block => block.type === 'paragraph' || block.type === 'heading' ? [block.text] : []).join('\n');
    const questions = prose.split(/\r?\n/).map(line => line.trim())
        .filter(line => !/^(?:>|[-*+]\s|\d+[.)]\s)/.test(line))
        .map(line => line.replace(/^#{1,6}\s+/, '').replace(/^\*\*(.*?)\*\*$/, '$1'))
        .filter(line => /^[^?]{5,499}\?$/.test(line));
    if (questions.length !== 1)
        return undefined;
    const options = followups.filter(value => typeof value === 'string' && !/^(?:something else|other|another answer)[.!]?$/i.test(value.trim()));
    if (options.length < 2 || options.length > 4 || !options.every(value => text(value, 100)))
        return undefined;
    return parseQuestions([{ id: 'q1', question: questions[0], options: options.map((label, index) => ({ id: `option${index + 1}`, label })), allowOther: true }]);
}
export function questionAnswer(questions, answers) {
    const lines = [];
    for (const question of questions) {
        const answer = answers[question.id];
        if (!answer)
            return null;
        const value = answer.option === 'other' ? answer.other?.trim() : question.options.find(option => option.id === answer.option)?.label;
        if (!value || value.length > 2000)
            return null;
        lines.push(`${question.question}\n${value}`);
    }
    return lines.length ? lines.join('\n\n') : null;
}
//# sourceMappingURL=clarificationQuestions.js.map